import React from 'react';
import { MenuList, MenuItem } from '@mui/material';
import { useRouter } from 'next/router';
import classNames from 'classnames';

import { IMenuLink } from '@/infrastructure/interfaces/i-link';
import { useAuth } from '@/infrastructure/context/auth-context';
import s from './styles.module.scss';

interface IAppNavbarMenuProps {
  className?: string;
  itemClassName?: string;
  links: IMenuLink[];
}

const AppNavbarMenu: React.FC<IAppNavbarMenuProps> = (props) => {
  const { links, className = '', itemClassName = '' } = props;

  const router = useRouter();
  const { pathname } = router;

  const appNavbarMenuClassNames = classNames(s['menu-list'], className);
  const appNavbarMenuItemClassNames = classNames(s['item'], itemClassName);

  const { checkAuth } = useAuth();

  const onAuthMenuItemClick = async (link: IMenuLink) => {
    await checkAuth();
    if (link.path) router.push(link.path);
  };

  const onMenuItemClick = (link: IMenuLink) => {
    if (link.path)
      router.push(link.path, link.path, {
        shallow: true,
      });
  };

  const isSelected = (path: string) =>
    pathname === path || (path !== '/' && pathname.startsWith(`${path}/`));

  return (
    <MenuList role="menu" className={appNavbarMenuClassNames}>
      {links.map(
        (link) =>
          link.path &&
          (link.authorized ? (
            <MenuItem
              key={link.path}
              className={appNavbarMenuItemClassNames}
              selected={isSelected(link.path)}
              onClick={() => onAuthMenuItemClick(link)}
              role="menuitem"
            >
              {link.icon && (
                <i className={s['icon']}>
                  <link.icon />
                </i>
              )}
              {link.title}
            </MenuItem>
          ) : (
            <MenuItem
              key={link.path}
              className={appNavbarMenuItemClassNames}
              selected={isSelected(link.path)}
              onClick={() => onMenuItemClick(link)}
              role="menuitem"
            >
              {link.icon && (
                <i className={s['icon']}>
                  <link.icon />
                </i>
              )}
              {link.title}
            </MenuItem>
          ))
      )}
    </MenuList>
  );
};

export default AppNavbarMenu;
